import { useState } from 'react';

import classNames from 'classnames';
import type { CSSProperties, JSX } from 'react';

import './Skeleton.less';

interface SkeletonProps {
  src: string;
  width: number;
  height: number;
  style?: CSSProperties;
  className?: string;
  alt: string;
  title?: string;
}

export function fixedWidthSrcString(source: string, width: number): string {
  return source.replace(/upload/, `upload/c_scale,q_100,w_${width}`);
}

export const Skeleton = ({ style = {}, width, height, src, alt, title, className }: SkeletonProps): JSX.Element => {
  const [loaded, setLoaded] = useState<boolean>(false);
  return (
    <>
      {!loaded && (
        <div
          className="skeleton-pulse"
          style={{
            width: width,
            height: height,
            ...style,
          }}
        />
      )}
      <div className={classNames('skeleton', className)} style={{ height: height, display: loaded ? (style.display ?? 'flex') : 'none' }}>
        <img
          src={fixedWidthSrcString(src, width)}
          width={width}
          height={height}
          onLoad={() => setLoaded(true)}
          style={{
            ...style,
          }}
          alt={alt}
          title={title}
          draggable="false"
        />
      </div>
    </>
  );
};
